import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
import { element } from '@pik-libs/utils';
import styled, { css } from 'styled-components';
import { colors, fontWeight, media } from '@pik-libs/styles';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var S = {};
S.VideoplayerWrapper = styled.div.withConfig({
  displayName: "styles__VideoplayerWrapper",
  componentId: "sc-1mavyyy-0"
})(["position:relative;"]);
S.VideoTitle = styled.div.withConfig({
  displayName: "styles__VideoTitle",
  componentId: "sc-1mavyyy-1"
})(["position:absolute;top:24px;left:24px;font-size:32px;line-height:32px;color:", ";font-weight:", ";@media ", "{top:16px;left:16px;font-size:16px;line-height:16px;}"], colors.white, fontWeight.medium, media.mobile);
S.Videoplayer = styled.video.withConfig({
  displayName: "styles__Videoplayer",
  componentId: "sc-1mavyyy-2"
})(["box-sizing:border-box;width:100%;height:100%;object-fit:cover;", " video{box-sizing:border-box;width:100%;height:100%;object-fit:cover;}.vjs-text-track-display,.vjs-loading-spinner,.vjs-big-play-button,.vjs-control-bar,.vjs-error-display,.vjs-modal-dialog,.vjs-loading-spinner{display:none;visibility:hidden;}"], function (_ref) {
  var flexDisplay = _ref.flexDisplay;
  return flexDisplay && css(["display:flex;"]);
});

var inViewPort = element.inViewPort;
var VideoPlayer = /*#__PURE__*/function (_PureComponent) {
  _inherits(VideoPlayer, _PureComponent);
  var _super = _createSuper(VideoPlayer);
  function VideoPlayer() {
    var _this;
    _classCallCheck(this, VideoPlayer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentPlayer: null,
      playing: false
    });
    _defineProperty(_assertThisInitialized(_this), "pause", function (currentPlayer) {
      currentPlayer.pause();
      currentPlayer.currentTime(0);
    });
    _defineProperty(_assertThisInitialized(_this), "play", function (currentPlayer) {
      currentPlayer.play();
      currentPlayer.loop(true);
    });
    _defineProperty(_assertThisInitialized(_this), "handlePlayOnHover", function () {
      var isMouseEntered = _this.props.isMouseEntered;
      var currentPlayer = _this.state.currentPlayer;
      if (currentPlayer && !isMouseEntered) {
        _this.pause(currentPlayer);
      }
      if (currentPlayer && isMouseEntered) {
        _this.play(currentPlayer);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handlePlayOnMobile", function () {
      var playOnMobile = _this.props.playOnMobile;
      var _this$state = _this.state,
        currentPlayer = _this$state.currentPlayer,
        playing = _this$state.playing;
      if (playOnMobile && currentPlayer) {
        _this.pause(currentPlayer);
        if (playing) {
          _this.play(currentPlayer);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleReady", function () {
      var onReady = _this.props.onReady;
      _this.setState({
        currentPlayer: _this.player
      });
      onReady();
    });
    _defineProperty(_assertThisInitialized(_this), "handleError", function () {
      var onError = _this.props.onError;
      onError();
    });
    _defineProperty(_assertThisInitialized(_this), "getOptions", function (src, srcType, poster) {
      return {
        autoplay: true,
        muted: true,
        responsive: true,
        controls: false,
        sources: [{
          src: src,
          type: srcType
        }],
        poster: poster
      };
    });
    _defineProperty(_assertThisInitialized(_this), "checkFadeIn", function () {
      var playing = _this.state.playing;
      if (!playing) {
        var viewPort = inViewPort(_this.playerContainer);
        if (viewPort) {
          return _this.setState({
            playing: true
          });
        }
      }
      return null;
    });
    return _this;
  }
  _createClass(VideoPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        src = _this$props.src,
        srcType = _this$props.srcType,
        poster = _this$props.poster;
      this.player = videojs(this.playerContainer, this.getOptions(src, srcType, poster), this.handleReady);
      this.player.on('error', this.handleError);
      window.addEventListener('scroll', this.checkFadeIn);
      this.checkFadeIn();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var _this2 = this;
      var prevSrc = _ref.src;
      var _this$props2 = this.props,
        src = _this$props2.src,
        srcType = _this$props2.srcType,
        poster = _this$props2.poster;
      this.handlePlayOnHover();
      this.handlePlayOnMobile();
      if (prevSrc && prevSrc !== src && this.player) {
        this.player.src([{
          src: src,
          type: srcType
        }]);
        this.player.poster(poster);
        setTimeout(function () {
          _this2.handleReady();
        }, 1000);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.checkFadeIn);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
        title = _this$props3.title,
        flexDisplay = _this$props3.flexDisplay;
      return /*#__PURE__*/React.createElement(S.VideoplayerWrapper, null, !!title && /*#__PURE__*/React.createElement(S.VideoTitle, {
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/React.createElement("div", {
        "data-vjs-player": true
      }, /*#__PURE__*/React.createElement(S.Videoplayer, {
        playsInline: true,
        muted: true,
        flexDisplay: flexDisplay,
        ref: function ref(el) {
          _this3.playerContainer = el;
        }
      })));
    }
  }]);
  return VideoPlayer;
}(PureComponent);
VideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  srcType: PropTypes.string,
  poster: PropTypes.string,
  title: PropTypes.string,
  onReady: PropTypes.func,
  onError: PropTypes.func,
  isMouseEntered: PropTypes.bool,
  playOnMobile: PropTypes.bool,
  flexDisplay: PropTypes.bool
};
VideoPlayer.defaultProps = {
  poster: null,
  title: null,
  srcType: undefined,
  playOnMobile: false,
  flexDisplay: false,
  onReady: function onReady() {
    return null;
  },
  onError: function onError() {
    return null;
  },
  isMouseEntered: function isMouseEntered() {
    return false;
  }
};

export { VideoPlayer as default };
